import {useMemo} from 'react';
import type {BrandKitWithAssets} from '@Components/mystuff-brands/brand-kits.types';
import {createBrandKitWithAssetsObject, getBrandFromList} from '@Libraries/brands-library';
import {useAppSelector} from '@/hooks';
import {useBrandKitAssetSources} from '@Hooks/brands/useBrandKitAssetSources';

export const useBrandKitWithAssets = (brandKitId: string): BrandKitWithAssets | null => {
  const brandKit = useAppSelector(({brands}) => {
    return getBrandFromList(brandKitId, brands.brands);
  });
  const assetSources = useBrandKitAssetSources();

  return useMemo(() => {
    return brandKit ? createBrandKitWithAssetsObject({brandKit, ...assetSources}) : null;
  }, [brandKit, assetSources]);
};
